const resources = [
  {
    title: 'Почему стоит работать с нами',
    link: 'https://www.youtube.com/watch?v=uLrsQBXSAnw&feature=youtu.be'
  },
  {
    title: 'Подкасты на ITunes',
    link: 'https://podcasts.apple.com/ae/podcast%D0%BF%D0%BE%D0%B4%D0%BA%D0%B0%D1%81%D1%82%D1%8B-uae-consulting-com/id1255782490?mt=2'
  },
  {
    title: 'Спецпроект с интервью',
    link: 'https://www.youtube.com/playlist?list=PL3JpB3BWN5KBnKjE8RpgX7pOAY0I1erkl'
  },
  {
    title: 'Вебинары',
    link: 'https://www.youtube.com/playlist?list=PL3JpB3BWN5KCIE-yjgWhCoZ6u32SNAe-o&disable_polymer=true'
  },
  {
    title: 'Маркетинг-кит',
    link: 'https://yadi.sk/i/P9rAUI5j7w2QwQ'
  }
]
const awards = [
  'https://stg-business-boutique.nyc3.digitaloceanspaces.com/images/award1.png',
  'https://stg-business-boutique.nyc3.digitaloceanspaces.com/images/award2.png',
  'https://stg-business-boutique.nyc3.digitaloceanspaces.com/images/award3.png',
  'https://stg-business-boutique.nyc3.digitaloceanspaces.com/images/award4.png',
  'https://stg-business-boutique.nyc3.digitaloceanspaces.com/uploads/email-files/images/1615376888469-award5.png'
]
const information = 'This email is off the record unless we agree otherwise.<br>' +
  'The information contained in this transmission may contain privileged and confidential information, ' +
  'as well as information subject to the protection of copyright and other applicable laws. ' +
  'It is intended only for use of those persons listed above. If you are not the intended recipient, ' +
  'you are hereby notified that any review, dissemination, ' +
  'distribution or duplication of this communication is strictly prohibited. ' +
  'Be advised that such illegal actions are governed by the Electronic Communications Privacy Act. ' +
  'All personal messages express solely the sender\'s view and not the views of the employer of the sender. ' +
  'If you are not the intended recipient, please contact the sender by reply email, destroy all copies of the original'
const companyPhone = '+97143684884'
const companySite = 'www.uae-consulting.com'
const companyAddress = 'Dubai, JLT, Cluster X, Jumeirah Bay X3 Tower, Office 310'
const companySkype = 'uae-consulting.com'
const additionalInformation = [
  {
    title: {
      ru: 'Мы предлагаем недвижимость в Эмиратах',
      en: 'We offer real estate in United Arab Emirates'
    },
    href: 'https://www.dubai-realty.com',
    link: 'www.dubai-realty.com',
    // eslint-disable-next-line max-len
    icon: 'https://stg-business-boutique.nyc3.digitaloceanspaces.com/uploads/email-files/images/1615379544648-building.png',
    width: '350px'
  },
  {
    title: {
      ru: 'Каталог объектов недвижимости 2021',
      en: 'Catalogue of real estate properties 2021'
    },
    href: 'https://dubai-realty.com/static/e6f9ca8be5ff59ce8a179e8cfcffbb27fe0fd8de.pdf',
    link: 'www.download.dubai-realty.com',
    icon: 'https://stg-business-boutique.nyc3.digitaloceanspaces.com/uploads/email-files/images/1615379521130-book.png',
    width: '320px'
  }
]

export {information, resources, companyPhone, companySite, companyAddress, awards, companySkype, additionalInformation}



// WEBPACK FOOTER //
// ./src/constants/signatureGmail/resources.js